/*
 * Vervit Track Order — Shiprocket API via Cloudflare Worker.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-vrv-track]');
    if (!root) return;
    if (root.dataset.vrvTrackInit === '1') return;
    root.dataset.vrvTrackInit = '1';

    var trackApi = root.dataset.trackApi || '';
    var trackingUrl = root.dataset.trackingUrl || 'https://shiprocket.co/tracking/';
    if (/shiprocket\.in\/shipment-tracking/i.test(trackingUrl)) {
      trackingUrl = 'https://shiprocket.co/tracking/';
    }
    if (trackingUrl.charAt(trackingUrl.length - 1) !== '/') trackingUrl += '/';

    function looksLikeShopifyOrderNumber(val) {
      var s = String(val || '').trim().replace(/^#/, '');
      if (!s) return false;
      if (/^(VF|VRV|VERVIT|ORD|VR|PM)[A-Z0-9]*$/i.test(s)) return true;
      if (/^[A-Z]{2,5}\d{2,8}$/i.test(s)) return true;
      if (/^\d{1,6}$/.test(s)) return true;
      return false;
    }

    function looksLikeAwb(val) {
      var s = String(val || '').trim().replace(/[^a-zA-Z0-9]/g, '');
      if (!s || looksLikeShopifyOrderNumber(s)) return false;
      var digits = (s.match(/\d/g) || []).length;
      return digits >= 8 && s.length >= 8;
    }

    function normalizeOrderKey(val) {
      return String(val || '').trim().replace(/^#/, '').toUpperCase();
    }

    function buildTrackingUrl(awb) {
      return trackingUrl + encodeURIComponent(awb);
    }

    var tabs = root.querySelectorAll('[data-vrv-track-tab]');
    var panels = root.querySelectorAll('[data-vrv-track-panel]');

    function clearPanelForm(panelName) {
      var panel = root.querySelector('[data-vrv-track-panel="' + panelName + '"]');
      if (!panel) return;
      panel.querySelectorAll('input').forEach(function (input) {
        input.value = '';
      });
      clearError(panel);
    }

    function activateTab(name, options) {
      options = options || {};
      tabs.forEach(function (btn) {
        var isActive = btn.dataset.vrvTrackTab === name;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var isActive = panel.dataset.vrvTrackPanel === name;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      if (!options.keepForm) {
        clearPanelForm(name);
        hideResult();
      }
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.dataset.vrvTrackTab);
      });
    });

    function showError(panel, message) {
      var err = panel && panel.querySelector('[data-vrv-track-error]');
      if (!err) return;
      err.querySelector('[data-vrv-track-error-text]').textContent = message;
      err.classList.add('is-visible');
      window.clearTimeout(err._hideTimer);
      err._hideTimer = window.setTimeout(function () {
        err.classList.remove('is-visible');
      }, 9000);
    }

    function clearError(panel) {
      var err = panel && panel.querySelector('[data-vrv-track-error]');
      if (err) err.classList.remove('is-visible');
    }

    function setLoading(form, on) {
      if (!form) return;
      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      btn.disabled = on;
      btn.classList.toggle('is-loading', on);
    }

    var resultEl = root.querySelector('[data-vrv-track-result]');
    var openShiprocket = root.querySelector('[data-vrv-track-open-shiprocket]');

    var els = {
      orderId: root.querySelector('[data-vrv-sr-order-id]'),
      shipments: root.querySelector('[data-vrv-sr-shipments]'),
      date: root.querySelector('[data-vrv-sr-date]'),
      awbRow: root.querySelector('[data-vrv-sr-awb-row]'),
      awb: root.querySelector('[data-vrv-sr-awb]'),
      status: root.querySelector('[data-vrv-sr-status]'),
      statusSub: root.querySelector('[data-vrv-sr-status-sub]'),
      imageWrap: root.querySelector('[data-vrv-sr-image-wrap]'),
      image: root.querySelector('[data-vrv-sr-image]'),
      productTitle: root.querySelector('[data-vrv-sr-product-title]'),
      productPrice: root.querySelector('[data-vrv-sr-product-price]'),
      activities: root.querySelector('[data-vrv-sr-activities]')
    };

    function hideResult() {
      if (resultEl) resultEl.hidden = true;
      if (openShiprocket) openShiprocket.hidden = true;
    }

    function renderActivities(list) {
      if (!els.activities) return;
      els.activities.innerHTML = '';
      if (!list || !list.length) {
        els.activities.hidden = true;
        return;
      }
      list.slice().reverse().forEach(function (item) {
        var li = document.createElement('li');
        var when = item.date ? '<time>' + item.date + '</time>' : '';
        var where = item.location ? '<span>' + item.location + '</span>' : '';
        li.innerHTML = when + '<strong>' + (item.activity || 'Update') + '</strong>' + where;
        els.activities.appendChild(li);
      });
      els.activities.hidden = false;
    }

    function showShiprocketResult(data) {
      if (!resultEl || !data) return;

      if (els.orderId) els.orderId.textContent = data.orderIdDisplay || data.orderId || '—';
      if (els.shipments) els.shipments.textContent = String(data.totalShipments || 1);
      if (els.date) els.date.textContent = data.orderDate || '—';

      if (els.awbRow && els.awb) {
        if (data.awb) {
          els.awb.textContent = data.awb;
          els.awbRow.hidden = false;
        } else {
          els.awbRow.hidden = true;
        }
      }

      if (els.status) els.status.textContent = data.statusLabel || 'Order Placed';
      if (els.statusSub) {
        els.statusSub.textContent = data.statusSub || '';
        els.statusSub.hidden = !data.statusSub;
        els.statusSub.className = 'vrv-track__sr-status-sub vrv-track__sr-status-sub--' + (data.statusTone || 'pending');
      }

      var product = data.product || {};
      if (els.productTitle) els.productTitle.textContent = product.title || 'Your Vervit order';
      if (els.productPrice) {
        if (product.price) {
          els.productPrice.textContent = product.price;
          els.productPrice.hidden = false;
        } else {
          els.productPrice.hidden = true;
        }
      }
      if (els.imageWrap && els.image) {
        if (product.image) {
          els.image.src = product.image;
          els.image.alt = product.title || 'Product';
          els.imageWrap.hidden = false;
        } else {
          els.imageWrap.hidden = true;
        }
      }

      renderActivities(data.activities);

      var shipUrl = data.trackingUrl || (data.awb ? buildTrackingUrl(data.awb) : '');
      if (openShiprocket) {
        if (shipUrl) {
          openShiprocket.href = shipUrl;
          openShiprocket.hidden = false;
        } else {
          openShiprocket.hidden = true;
        }
      }

      resultEl.hidden = false;
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function fetchTracking(payload) {
      if (!trackApi) {
        return Promise.reject(new Error('Track API URL is not configured on this page.'));
      }
      return fetch(trackApi, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok || !body.ok) {
            var msg = (body && body.message) || 'Could not fetch tracking from Shiprocket.';
            throw new Error(msg);
          }
          return body.data;
        });
      });
    }

    function lookupOrder(orderKey, orderPanel, orderForm, email) {
      setLoading(orderForm, true);
      var payload = { order_id: orderKey };
      if (email) payload.email = email;

      fetchTracking(payload)
        .then(function (data) {
          clearError(orderPanel);
          showShiprocketResult(data);
        })
        .catch(function (err) {
          showError(orderPanel, err.message || 'Tracking lookup failed. Please try again.');
          hideResult();
        })
        .finally(function () {
          setLoading(orderForm, false);
        });
    }

    function lookupPhone(phone10, phonePanel, phoneForm) {
      setLoading(phoneForm, true);
      fetchTracking({ phone: phone10 })
        .then(function (data) {
          clearError(phonePanel);
          showShiprocketResult(data);
        })
        .catch(function (err) {
          showError(phonePanel, err.message || 'No orders found for this mobile number.');
          hideResult();
        })
        .finally(function () {
          setLoading(phoneForm, false);
        });
    }

    function lookupAwb(awb, awbPanel, awbForm) {
      setLoading(awbForm, true);
      fetchTracking({ awb: awb })
        .then(function (data) {
          clearError(awbPanel);
          showShiprocketResult(data);
        })
        .catch(function (err) {
          showError(awbPanel, err.message || 'AWB not found in Shiprocket.');
          hideResult();
        })
        .finally(function () {
          setLoading(awbForm, false);
        });
    }

    /* ---- AWB form ---- */
    var awbForm = root.querySelector('[data-vrv-track-form="awb"]');
    if (awbForm) {
      var awbPanel = awbForm.closest('[data-vrv-track-panel]');
      awbForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError(awbPanel);
        hideResult();
        var awbInput = awbForm.querySelector('[name="awb"]');
        var awb = (awbInput.value || '').trim();
        awb = awb.replace(/[^a-zA-Z0-9-]/g, '');

        if (looksLikeShopifyOrderNumber(awb)) {
          showError(
            awbPanel,
            'This looks like your order number (e.g. #VF1008), not an AWB. Switch to the "By Order Number" tab.'
          );
          activateTab('order');
          var orderInputSwitch = root.querySelector('[name="order_number"]');
          if (orderInputSwitch) orderInputSwitch.value = awb.replace(/^#/, '');
          awbInput.value = '';
          if (orderInputSwitch) orderInputSwitch.focus();
          return;
        }

        if (!looksLikeAwb(awb)) {
          showError(
            awbPanel,
            'Please enter a valid courier AWB (usually 8–14 digits from your shipping SMS/email).'
          );
          awbInput.focus();
          return;
        }

        lookupAwb(awb, awbPanel, awbForm);
      });
    }

    /* ---- Order # form ---- */
    var orderForm = root.querySelector('[data-vrv-track-form="order"]');
    var orderPanel = orderForm && orderForm.closest('[data-vrv-track-panel]');

    if (orderForm) {
      orderForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError(orderPanel);
        hideResult();

        var orderInput = orderForm.querySelector('[name="order_number"]');
        var emailInput = orderForm.querySelector('[name="email"]');
        var order = normalizeOrderKey(orderInput && orderInput.value);
        var email = (emailInput && emailInput.value || '').trim();

        if (!order) {
          showError(orderPanel, 'Please enter your order number (e.g. #VF1008).');
          if (orderInput) orderInput.focus();
          return;
        }

        if (email && email.indexOf('@') === -1) {
          showError(orderPanel, 'Please enter a valid email address.');
          if (emailInput) emailInput.focus();
          return;
        }

        lookupOrder(order, orderPanel, orderForm, email || '');
      });
    }

    /* ---- Mobile number form ---- */
    var phoneForm = root.querySelector('[data-vrv-track-form="phone"]');
    var phonePanel = phoneForm && phoneForm.closest('[data-vrv-track-panel]');

    if (phoneForm) {
      var phoneInput = phoneForm.querySelector('[name="phone"]');
      if (phoneInput) {
        phoneInput.addEventListener('input', function () {
          phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
        });
      }
      phoneForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError(phonePanel);
        hideResult();

        var phone10 = String((phoneInput && phoneInput.value) || '').replace(/\D/g, '').slice(-10);
        if (phone10.length !== 10) {
          showError(phonePanel, 'Please enter the 10-digit mobile number used at checkout.');
          if (phoneInput) phoneInput.focus();
          return;
        }

        lookupPhone(phone10, phonePanel, phoneForm);
      });
    }

    /* ---- Pre-fill from query string ---- */
    try {
      var qs = new URLSearchParams(window.location.search);
      var awbParam = qs.get('awb') || qs.get('tracking') || qs.get('tracking_number');
      var orderParam = qs.get('order') || qs.get('order_number');
      var emailParam = qs.get('email');
      var phoneParam = qs.get('phone') || qs.get('mobile');
      var autoLookup = qs.get('lookup') === '1';

      if (phoneParam) {
        var phoneDigits = String(phoneParam).replace(/\D/g, '').slice(-10);
        activateTab('phone', { keepForm: true });
        var phoneInput2 = root.querySelector('[name="phone"]');
        if (phoneInput2) phoneInput2.value = phoneDigits;
        if (autoLookup && phoneForm && phoneDigits.length === 10) {
          phoneForm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      } else if (orderParam) {
        activateTab('order', { keepForm: true });
        var orderInput2 = root.querySelector('[name="order_number"]');
        if (orderInput2) orderInput2.value = orderParam.replace(/^#/, '');
        if (emailParam) {
          var emailInput2 = root.querySelector('[name="email"]');
          if (emailInput2) emailInput2.value = emailParam;
        }
        if (autoLookup && orderForm) {
          orderForm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      } else if (awbParam) {
        if (looksLikeShopifyOrderNumber(awbParam)) {
          activateTab('order', { keepForm: true });
          var orderFromAwb = root.querySelector('[name="order_number"]');
          if (orderFromAwb) orderFromAwb.value = awbParam.replace(/^#/, '');
        } else {
          activateTab('awb', { keepForm: true });
          var awbInput2 = root.querySelector('[name="awb"]');
          if (awbInput2) {
            awbInput2.value = awbParam;
            if (awbForm && looksLikeAwb(awbParam)) {
              awbForm.dispatchEvent(new Event('submit', { cancelable: true }));
            }
          }
        }
      }
    } catch (err) {
      /* ignore */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
